import { render, staticRenderFns } from "./SampleItem.vue?vue&type=template&id=dce66922&scoped=true&"
import script from "./SampleItem.vue?vue&type=script&lang=js&"
export * from "./SampleItem.vue?vue&type=script&lang=js&"
import style0 from "./SampleItem.vue?vue&type=style&index=0&id=dce66922&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce66922",
  null
  
)

export default component.exports